const generalPart = {
  equipment: {
    laboratories: [
      'Basic laboratory',
      'Chemical laboratory',
      'Biochemical laboratory',
      'Biological laboratory',
    ],
    textFields: [
      {
        label: 'Processes (sample preparation) performed by users during the experiment at SOLARIS',
        isRequired: false,
        restriction: '',
        model: 'process_in_lab',
      },
      {
        label: 'Equipment and products requested from the facility',
        isRequired: false,
        restriction: '',
        model: 'solaris_equipment',
      },
      {
        label: 'Equipment and products to be provided by the user',
        isRequired: false,
        restriction: 'Including safety precautions to operate equipment '
          + '(e.g. electrically safe, secured overheating, explosion secured)',
        model: 'user_equipment',
      },
    ],
  },
  additionalInfo: {
    diplomaThesesOptions: [
      "No. bachelor's/engineering theses",
      "No. master's theses",
      'No. doctoral theses',
      'No. habilitation theses',
    ],
    experimentExperienceDescriptionOptions: [{
      label: 'Where did you get your experience with experiments of this type?',
      isRequired: true,
      restriction: '',
      model: 'experience_description',
    }],
  },
};

export { generalPart };
